module.exports = __webpack_public_path__ + "img/pic_331590.0a42032c.jpg";